<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
      content-class="mainModal"
    >
      <template v-slot:activator="{ on, attrs }">
        <div  class="float">
          <v-fab-transition v-if="editable">
            <v-btn
              class="floatButton"
              color="green"
              width="14px"
              height="14px"
              plain
              text
              absolute
              top
              right
              fab
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-textarea
            class="textArea"
            height="50px"
            v-bind="attrs"
            v-on="on"
            solo
            hide-details="true"
            readonly
            :value="resume"
            no-resize
          ></v-textarea>
        </div>
      </template>

      <v-card class="cardModal" elevation="0">
        <div class="input-wrapper textAreaModal">
          <h2 class="titleSection">{{title}}</h2>
          <div v-if="editable">
            <p>Lo que escribas en <b>{{title}}</b> se propagará a todos los alumnos.</p>
          </div>
          <v-textarea
            outlined
            :label="`Mensaje a: ${student}`"
            v-model="inputVal"
            counter="250"
            auto-grow
            rows="3"
            >
          </v-textarea>
        </div>
        <div class="d-flex align-center justify-space-between">
          <v-btn
              color="error"
              depressed
              @click="clear()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              depressed
              @click="propagateChange()"
            >
              Aceptar
            </v-btn>
            
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  // components: { BasicButton },
  created: function () {
    this.value = (!this.byDefault) ? '' : this.byDefault
    this.editable = this.edit
    this.inputVal = this.value
  },
  props: {
    title: String,
    edit: Boolean,
    student: String,
    byDefault: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      inputVal: '',
      dialog: false,
      value: undefined
    }
  },
  computed: {
    resume () {
      return this.value.substring(0, 20)
    }
  },
  methods: {
    setValue: function (value) {
      this.value = value
      this.inputVal = value
      this.propagateChange()
    },
    clear: function () {
      console.log('cleeeeeearrr')
      this.inputVal = this.value
      this.dialog = false
    },
    setEnable: function (value) {
      this.enabled = value
    },
    propagateChange: function () {
      console.log({basicModal: this.inputVal})
      this.value = this.inputVal
      this.dialog = false
      this.$emit('selectedElement',
        { item: this.inputVal }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/TextAreaInputModal.vue